import Component from "./gamification.component";
import { Config } from "./gamification.config";
import { watchGamification as saga } from "./redux/gamification.sagas";
import { reducer } from "./redux/gamification.reducer";

export default { Component, saga, reducer, config: Config };
